<template>
  <div class="ly_mainInner">
    <div id="selectStage">
      <div class="bl_txtBlock">
        <p>ステージをえらぶ</p>
      </div>
      <ul class="bl_selectStageBtnBlock">
        <li v-for="m in 4" :key="m" class="bl_selectStageBtn" :class="isClearStage(m)">
          <input v-model="selectLevel.stage" type="radio" :id="m" :value="m">
          <label :for="m" :class="checkedLabel(selectLevel.stage, m)">
            <!-- eslint-disable-next-line -->
            {{ selectLevel.grade }}<ruby>級<rp>(</rp><rt>きゅう</rt><rp>)</rp></ruby> ステージ {{ m }}
            <span v-if="is_clear_stage" class="el_stageClearStamp"></span>
          </label>
        </li>
      </ul>
      <div class="bl_btnBlock">
        <a class="el_btn" href="#" @click="changeCurrentPage('selectGrade')">もどる</a>
        <a class="el_btn" href="#" @click="isStage()">このステージにチャレンジ</a>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex';

export default {
  name: 'SelectStage',
  data() {
    return {
      backgroundColor: {
        hp_bgColor_1: false,
        hp_bgColor_2: false,
        hp_bgColor_3: false,
        hp_bgColor_4: false,
        hp_bgColor_5: false,
      },
      clearStageCount: '',
    };
  },
  computed: {
    // クリアしたデータを取得
    ...mapState('odakyuQuizClearData', [
      'clearData',
    ]),
    // ステージ選択画面から選択した級などを取得
    ...mapState('selectLevel', [
      'selectLevel',
    ]),
  },
  created() {
    // 級に合わせて背景色をセット
    this.$set(this.backgroundColor, `hp_bgColor_${this.selectLevel.grade}`, true);
    // クリアしたステージ数の合計を保持
    this.clearStageCount = this.stageCount(this.clearData.grade, this.clearData.stage);
  },
  methods: {
    // ページ遷移
    changeCurrentPage(page) {
      this.$store.commit('currentPage/changeCurrentPage', page);
    },
    // クリアしたステージか
    isClearStage(m) {
      const stageCount = this.stageCount(this.selectLevel.grade, m);
      if (this.clearStageCount >= stageCount) {
        this.is_clear_stage = true;
        return {
          is_clear_stage: true,
        };
      }
      this.is_clear_stage = false;
      return {
        is_clear_stage: false,
      };
    },
    // ステージを選択しているか
    isStage() {
      const selectStageCount = this.stageCount(this.selectLevel.grade, this.selectLevel.stage);
      if (this.selectLevel.stage > 0 && this.selectLevel.stage <= 4) {
        if (this.clearStageCount + 1 >= selectStageCount) {
          this.selectLevel.questionCount = 1;
          this.$store.commit('selectLevel/setSelectLevel', this.selectLevel);
          this.changeCurrentPage('question');
        }
      } else {
        return false;
      }
      return false;
    },
    // checkeされたらlabelの背景色を変更
    checkedLabel(checked, index) {
      if (checked === index) {
        return this.backgroundColor;
      }
      return false;
    },
    // 選択された級によってステージの選択ボタンの背景色をセット
    setBgColor(grade) {
      this.bgColorReset();
      this.$set(this.backgroundColor, `hp_bgColor_${grade}`, true);
    },
    // 背景色をリセット
    bgColorReset() {
      Object.keys(this.backgroundColor).forEach((key) => {
        this.backgroundColor[key] = 0;
      });
    },
    // クリアしたステージ数の合計を算出
    stageCount(grade, stage) {
      if (grade !== 0) {
        return (((5 - grade) * 4) + stage);
      }
      return 0;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

ruby{
  > rt{
    font-size: 10px;
  }
}

.el_stageClearStamp {
  position: absolute;
  top: 0;
  left: 0;
  background: url('/kids/quiz/static/image/clear_img_02.png') center left 17px no-repeat;
  background-size: auto 70%;
  width: 100%;
  height: 100%;
  opacity: 1;
  z-index: 1;
}

.ly_main{
  .el_btn{
    max-width: 324.7px;
  }

  .ly_mainInner{
    .bl_txtBlock{
      font-size: 34px;
      font-weight: bold;
      text-align: center;
      margin-bottom: 60px;
    }

    .bl_noteBlock{
      display: flex;
      flex-flow: row-reverse;
      justify-content: center;
      align-items: center;
      margin-bottom: 32.7px;

      .bl_noteBlock_txt{
        background: url(/kids/quiz/static/image/select_img_01.png) center left no-repeat;
        background-size: 100%;
        position: relative;
        margin-left: 4px;
        padding: 23px 23px 23px 60px;

        > p{
          position: absolute;
          top: 30%;
          left: 59px;
          font-size: 22px;
        }
      }

      .bl_noteBlock_img{
        width: 160px;
      }
    }

    #selectStage{
      width: 100%;

      .bl_selectStageBtnBlock{
        max-width: 832px;
        width: 100%;
        margin: 0 auto 40px;

        .bl_selectStageBtn{
          box-sizing: border-box;
          width: 100%;
          height: 74px;
          margin-bottom: 10px;
          position: relative;
          line-height: 74px;
          font-size: 24px;
          font-weight: bold;
          text-align: center;
          color: #ada49b;

          &:last-of-type{
            margin-bottom: 0;
          }

          > label{
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            border-radius: 10px;
            border: 3px solid #ada49b;
            pointer-events: none;
          }

          &.is_clear_stage{
            > label{
              background-color: #fff;
              border: none;
              color: #000;
              cursor: pointer;
              pointer-events: painted;
            }

            + li{
              > label{
                background-color: #fff;
                border: none;
                color: #000;
                cursor: pointer;
                pointer-events: painted;
              }
            }
          }

          &:first-of-type{
            > label{
              background-color: #fff;
              border: none;
              color: #000;
              cursor: pointer;
              pointer-events: painted;
            }
          }

          input[type=radio] {
            &:checked{
              + label{
                color: #fff;
              }
            }
          }
        }
      }

      .bl_btnBlock{
        margin: 0 auto;
        display: flex;
        justify-content: center;

        .el_btn{
          margin-right: 10px;

          &:last-of-type{
            margin-right: 0;
          }
        }
      }
    }
  }
}


@media screen and (max-width: 768px){
  .ly_main{
    .ly_mainInner{

      .bl_txtBlock{
        font-size: 26px;
        margin-bottom: 32px;
      }

      #selectStage{
        .bl_selectStageBtnBlock{
          margin-bottom: 21px;

          .bl_selectStageBtn{
            font-size: 18px;

            &.is_clear_stage{
              > label{
                &::after{
                  background-size: auto 50%;
                }
              }
            }
          }
        }

        .bl_btnBlock{
          flex-direction: column-reverse;

          .el_btn{
            margin-right: 0;
            margin-bottom: 10px;

            &:first-of-type{
              margin-bottom: 0;
            }
          }
        }
      }
    }
  }
}
@media all and (-ms-high-contrast:none){
  .ly_main{
    .ly_mainInner{
      #selectStage{
        .bl_selectStageBtnBlock{
          .bl_selectStageBtn{
            > label{
              line-height: 0;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SelectStage.vue